import React, { useMemo } from 'react';
import { useStoreState } from '@proscom/prostore-react';
import { LocationStore } from '@proscom/prostore-react-router/lib/LocationStore';
import {
  TransformedQueryParams,
  URL_KEY_EVENT,
  URL_KEY_PAGE,
  URL_KEY_DISTANT_TYPE,
  URL_KEY_VACATION_TYPE,
  URL_KEY_VACATION_SUBTYPE
} from '../../../../store/urlKeys';
import { UserFilter } from '../../../../graphql/types';

import { AbsenceTypesStoreState } from '../../../../store/AbsenceTypesStore';
import { Checkbox } from '../../ui/Checkbox/Checkbox';
import { Event } from './FilterEvent';
import s from '../../ui/Filter/Filter.module.scss';

const DISTANT_WORK_TYPES = {
  1: 'Дистанционная работа',
  2: 'Комбинированный график'
};

const MAIN_VACATION_TYPE = '1';

// разбирает список всех причин отсутствия на типы и подтипы
export const getVacationTypesAndSubtypes = (allVacationTypes) => {
  const vacationTypes: String[] = [];
  const vacationSubTypes: String[] = [];

  allVacationTypes.forEach((vacationType) => {
    if (vacationType.checkbox !== 'Не детализируется') {
      vacationSubTypes.push(vacationType.checkbox);
    }
    vacationTypes.push(vacationType.category);
  });

  let uniqueTypes = [...new Set(vacationTypes)];
  let uniqueSubTypes = [...new Set(vacationSubTypes)];

  return {
    types: uniqueTypes,
    subtypes: uniqueSubTypes
  };
};

export interface FilterAbsenceProps {
  query: TransformedQueryParams;
  filter: UserFilter;
  onFilterChange: () => void;
  changeQuery: LocationStore['changeQuery'];
  handleFilterChange: (
    key: string,
    valueConverter?: (value) => any
  ) => (value: any) => void;
  className?: string;
}

export const FilterAbsence: React.FC<FilterAbsenceProps> = ({
  query,
  filter,
  onFilterChange,
  changeQuery,
  handleFilterChange,
  className
}) => {
  const currentEvent: Event | undefined = query[URL_KEY_EVENT];

  const { absenceTypes } = useStoreState<AbsenceTypesStoreState>(
    'STORE_ABSENCE_TYPES'
  );

  const types = useMemo(() => {
    return getVacationTypesAndSubtypes(absenceTypes);
  }, [absenceTypes]);

  const vacationTypes = types.types;
  const vacationSubtypes = types.subtypes;

  const isCheckboxChecked = (urlKey, reason) => {
    return query[urlKey]?.split(',').includes(reason);
  };

  const onCheckboxChange = (checked, urlKey, reason) => {
    const currentSelected = query[urlKey];
    let arr: String[] = [];
    if (currentSelected !== undefined && currentSelected.length) {
      arr = [...currentSelected.split(',')];
    }

    if (!checked) {
      arr = arr.filter((val) => val !== reason);
    } else {
      arr.push(reason);
    }

    if (!arr.length) {
      handleFilterChange(urlKey)(undefined);
    } else {
      handleFilterChange(urlKey)([arr]);
    }
    onFilterChange();
  };

  const isShowVacationSubtypes = query[URL_KEY_VACATION_TYPE]
    ? query[URL_KEY_VACATION_TYPE].split(',').includes(MAIN_VACATION_TYPE)
    : false;

  return (
    <>
      <div className={className}>
        {currentEvent === Event.vacations && (
          <div className={className}>
            <div className={s.Filter__label}>Типы отсутствий</div>
            {Object.keys(vacationTypes).map((reason) => {
              const reasonName = vacationTypes[reason];

              return (
                <Checkbox
                  key={reasonName}
                  checked={isCheckboxChecked(URL_KEY_VACATION_TYPE, reason)}
                  onChange={(checked) => {
                    const currentSelected = query[URL_KEY_VACATION_TYPE];
                    let arr: String[] = [];
                    if (
                      currentSelected !== undefined &&
                      currentSelected.length
                    ) {
                      arr = [...currentSelected.split(',')];
                    }

                    let subtypes = query[URL_KEY_VACATION_SUBTYPE];
                    if (!checked) {
                      // костыльно убираем и добавляем все подтипы основного отпуска при его отметке
                      arr = arr.filter((val) => val !== reason);
                      if (reason === MAIN_VACATION_TYPE) {
                        subtypes = undefined;
                      }
                    } else {
                      arr.push(reason);
                      if (reason === MAIN_VACATION_TYPE) {
                        subtypes = Object.keys(vacationSubtypes).join(',');
                      }
                    }

                    if (!arr.length) {
                      changeQuery({
                        [URL_KEY_VACATION_TYPE]: undefined,
                        [URL_KEY_VACATION_SUBTYPE]: undefined,
                        [URL_KEY_PAGE]: 1
                      });
                    } else {
                      changeQuery({
                        [URL_KEY_VACATION_TYPE]: [arr],
                        [URL_KEY_VACATION_SUBTYPE]: subtypes,
                        [URL_KEY_PAGE]: 1
                      });
                    }
                    onFilterChange();
                  }}
                  label={reasonName}
                />
              );
            })}
          </div>
        )}
      </div>
      <div className={className}>
        {currentEvent === Event.dist_work && (
          <div className={className}>
            <div className={s.Filter__label}>Дистанционная работа</div>
            {Object.keys(DISTANT_WORK_TYPES).map((reason) => {
              const reasonName = DISTANT_WORK_TYPES[reason];

              return (
                <Checkbox
                  key={reasonName}
                  checked={isCheckboxChecked(URL_KEY_DISTANT_TYPE, reason)}
                  onChange={(checked) =>
                    onCheckboxChange(checked, URL_KEY_DISTANT_TYPE, reason)
                  }
                  label={reasonName}
                />
              );
            })}
          </div>
        )}
      </div>
    </>
  );
};
